import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signup } from '../utils/api'; // Corrected import
import { decrypt, encrypt } from '../utils/cryptoUtils';
import Logo from "../assets/FullLogo.png";
import { RegisterOtp } from "../redux/LoginSlice";
import { useDispatch } from 'react-redux';

const Register = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSignInClick = () => {
    navigate('/login');
  };

  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const [ConfirmPassword, setConfirmPassword] = useState(false);
  const togglePasswordVisibility1 = () => {
    setConfirmPassword(!ConfirmPassword);
  };






  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    business_name: '',
    businessType: '',
    serviceType: '',
    password: '',
    confirmPassword: '',
    termsCheckbox: false,
  });

  const [errors, setErrors] = useState({
    nameError: '',
    emailError: '',
    phoneError: '',
    businessNameError: '',
    businessTypeError: '',
    serviceTypeError: '',
    passwordError: '',
    confirmPasswordError: '',
    checkboxError: '',
    generalError: '', // Added for general error handling
  });

  const handleChange = (e) => {
    const { id, value, type, checked } = e.target;
    //if (!/^\d*$/.test(value)) return; // Allows only digits

    setFormData({
      ...formData,
      [id]: type === 'checkbox' ? checked : value,
    });
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {
      nameError: '',
      emailError: '',
      phoneError: '',
      businessNameError: '',
      businessTypeError: '',
      serviceTypeError: '',
      passwordError: '',
      confirmPasswordError: '',
      checkboxError: '',
      generalError: '',
    };

    // Name validation
    if (!formData.name.trim()) {
      newErrors.nameError = 'Name is required.';
      isValid = false;
    } else if (!/^[a-zA-Z\s]+$/.test(formData.name)) {
      newErrors.nameError = 'Only alphabets and spaces allowed.';
      isValid = false;
    }

    // Email validation
    if (!formData.email.match(/^\S+@\S+\.\S+$/)) {
      newErrors.emailError = 'Invalid email.';
      isValid = false;
    }

    // Phone validation
    if (!formData.phone.match(/^\d{10}$/)) {
      newErrors.phoneError = 'Enter a valid phone number.';
      isValid = false;
    }

    // Business Name validation
    if (!formData.business_name.trim()) {
      newErrors.businessNameError = 'Business Name is required.';
      isValid = false;
    }

    // Business Type validation
    if (!formData.businessType) {
      newErrors.businessTypeError = 'Choose a business type.';
      isValid = false;
    }

    // Service Type validation
    if (!formData.serviceType) {
      newErrors.serviceTypeError = 'Choose a service type.';
      isValid = false;
    }

    // Password validation
    
    if (!formData.password.trim()) {
      newErrors.passwordError = 'Password is required.';
      isValid = false;
    } else if (formData.password.length < 6) {
      newErrors.passwordError = 'Password must be at least 6 characters.';
      isValid = false;
    } else if (!/[A-Z]/.test(formData.password)) {
      newErrors.passwordError = 'One uppercase required.';
      isValid = false;
    } else if (!/[0-9]/.test(formData.password)) {
      newErrors.passwordError = 'One number required.';
      isValid = false;
    }

    // Confirm Password validation
    if (!formData.confirmPassword) {
      newErrors.confirmPasswordError = 'Confirm password required.';
      isValid = false;
    } else if (formData.confirmPassword !== formData.password) {
      newErrors.confirmPasswordError = 'Passwords do not match.';
      isValid = false;
    }

    // Checkbox validation
    if (!formData.termsCheckbox) {
      newErrors.checkboxError = 'You must agree to the terms.';
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    try {
      const jsonData = JSON.stringify({
        name: formData.name,
        email: formData.email,
        mobile: formData.phone,
        business_name: formData.business_name,
        businessType: formData.businessType,
        serviceType: formData.serviceType,
        password: formData.password,
      });

      const encrypted = encrypt(jsonData);

      console.log('Encrypted Data:', encrypted);
      console.log('Decrypted Data:', decrypt(encrypted));

      const response = await signup(encrypted); // Corrected function call

      dispatch(RegisterOtp(response));

      navigate("/otp")
    } catch (err) {
      console.error('Register Error:', err.message);
      setErrors({ ...errors, generalError: err.message }); // Updated error handling
    }
  };

  return (
    <div className="flex flex-col lg:flex-row h-screen">
      {/* Left Side - Form */}
      <div className="w-full h-screen lg:w-1/2 flex flex-col justify-center items-center bg-white p-6 md:p-10">
        <div class="mb-10">
          <img src={Logo} alt="Company Logo" class="h-64" />
        </div>
        <div className="w-full max-w-md">
          <h2 className="text-2xl font-bold mb-2">Sign Up</h2>
          <p className="text-gray-500 mb-6">
            Enter your email and password to sign in!
          </p>
          <form onSubmit={handleSubmit}>
            {/* Name Field */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Name<span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                id="name"
                placeholder="Enter Name"
                // className="mt-1 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs"
                className={`w-full px-4 py-2 rounded-md border ${
                  errors.nameError ? 'border-red-500' : 'border-gray-300'
                } focus:outline-none focus:ring-2 placeholder:text-xs text-xs ${
                  errors.nameError ? 'focus:ring-red-400' : 'focus:ring-[#299F1F]'
                }`}
                value={formData.name}
                onChange={handleChange}
              />
              {errors.nameError && (
                <p className="text-red-500 text-xs mt-1">{errors.nameError}</p>
              )}
            </div>

            {/* Email and Phone Fields */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Email<span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  id="email"
                  placeholder="Enter your Email"
                  // className="mt-1 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs"
                  className={`w-full px-4 py-2 rounded-md border ${
                    errors.emailError ? 'border-red-500' : 'border-gray-300'
                  } focus:outline-none focus:ring-2 placeholder:text-xs text-xs ${
                    errors.emailError ? 'focus:ring-red-400' : 'focus:ring-[#299F1F]'
                  }`}
                  value={formData.email}
                  onChange={handleChange}
                />
                {errors.emailError && (
                  <p className="text-red-500 text-xs mt-1">{errors.emailError}</p>
                )}
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Phone Number<span className="text-red-500">*</span>
                </label>
                <input
                  type="tel"
                  id="phone"
                  maxLength="10"
                  placeholder="Enter phone number"
                  onInput={(e) =>
                    (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                  }
                  // className="mt-1 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs"
                  className={`w-full px-4 py-2 rounded-md border ${
                    errors.phoneError ? 'border-red-500' : 'border-gray-300'
                  } focus:outline-none focus:ring-2 placeholder:text-xs text-xs ${
                    errors.phoneError ? 'focus:ring-red-400' : 'focus:ring-[#299F1F]'
                  }`}
                  value={formData.phone}
                  onChange={handleChange}
                />
                {errors.phoneError && (
                  <p className="text-red-500 text-xs mt-1">{errors.phoneError}</p>
                )}
              </div>
            </div>

            {/* Business Name and Business Type Fields */}
            <div className="grid grid-cols-2 gap-4 mt-2">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Business Name<span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="business_name"
                  placeholder="Enter business name"
                  // className="mt-1 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs"
                  className={`w-full px-4 py-2 rounded-md border ${
                    errors.businessNameError ? 'border-red-500' : 'border-gray-300'
                  } focus:outline-none focus:ring-2 placeholder:text-xs text-xs ${
                    errors.businessNameError ? 'focus:ring-red-400' : 'focus:ring-[#299F1F]'
                  }`}
                  value={formData.business_name}
                  onChange={handleChange}
                />
                {errors.businessNameError && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.businessNameError}
                  </p>
                )}
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                    Business Type<span className="text-red-500">*</span>
                </label>
                <select
                  id="businessType"
                  // className="mt-1 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs"
                  className={`w-full px-4 py-2 rounded-md border ${
                    errors.businessTypeError ? 'border-red-500' : 'border-gray-300'
                  } focus:outline-none focus:ring-2 placeholder:text-xs text-xs ${
                    errors.businessTypeError ? 'focus:ring-red-400' : 'focus:ring-[#299F1F]'
                  }`}
                  value={formData.businessType}
                  onChange={handleChange}
                >
                  <option value="">Select Type</option>
                  <option value="1">Individual</option>
                  <option value="2">LLP</option>
                  <option value="3">Partnership</option>
                  <option value="4">Private Limited</option>
                  <option value="5">Proprietorship</option>
                  {/* <option value="6">NGO</option> */}
                </select>
                {errors.businessTypeError && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.businessTypeError}
                  </p>
                )}
              </div>
            </div>

            {/* Service Type Field */}
            <div className="mt-2">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Choose Service<span className="text-red-500">*</span>
              </label>
              <select
                id="serviceType"
                // className="mt-1 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs"
                className={`w-full px-4 py-2 rounded-md border ${
                  errors.serviceTypeError ? 'border-red-500' : 'border-gray-300'
                } focus:outline-none focus:ring-2 placeholder:text-xs text-xs ${
                  errors.serviceTypeError ? 'focus:ring-red-400' : 'focus:ring-[#299F1F]'
                }`}
                value={formData.serviceType}
                onChange={handleChange}
              >
                <option value="">Select Service</option>
                <option value="DMT">DMT</option>
                <option value="PG Domestic">PG Domestic</option>
                {/* <option value="PG International">PG International</option> */}
                <option value="Payouts">Payouts</option>
                <option value="UPI Collections">UPI Collections</option>
                {/* <option value="Gaming Payouts">Gaming Payouts</option>
                <option value="Gaming Collections">Gaming Collections</option> */}
                {/* <option value="Bank Account Opening">Bank Account Opening</option> */}
              </select>
              {errors.serviceTypeError && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.serviceTypeError}
                </p>
              )}
            </div>

            {/* Password and Confirm Password Fields */}
            <div className="grid grid-cols-2 gap-4 mt-2">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Password<span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    placeholder="Enter password"
                    // className="mt-1 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs"
                    className={`w-full px-4 py-2 rounded-md border ${
                      errors.passwordError ? 'border-red-500' : 'border-gray-300'
                    } focus:outline-none focus:ring-2 placeholder:text-xs text-xs pr-10 ${
                      errors.passwordError ? 'focus:ring-red-400' : 'focus:ring-[#299F1F]'
                    }`}
                    value={formData.password}
                    onChange={handleChange}
                  />
                  {/* Eye icon with toggle functionality */}
                  <span
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                    onClick={togglePasswordVisibility}
                  >
                    {showPassword ? (
                      // 👁️‍🗨️ Eye Open SVG

                      <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill="#434343"><path d="m637-425-62-62q4-38-23-65.5T487-576l-62-62q13-5 27-7.5t28-2.5q70 0 119 49t49 119q0 14-2.5 28t-8.5 27Zm133 133-52-52q36-28 65.5-61.5T833-480q-49-101-144.5-158.5T480-696q-26 0-51 3t-49 10l-58-58q38-15 77.5-21t80.5-6q143 0 261.5 77.5T912-480q-22 57-58.5 103.5T770-292Zm-2 202L638-220q-38 14-77.5 21t-80.5 7q-143 0-261.5-77.5T48-480q22-57 58-104t84-85L90-769l51-51 678 679-51 51ZM241-617q-35 28-65 61.5T127-480q49 101 144.5 158.5T480-264q26 0 51-3.5t50-9.5l-45-45q-14 5-28 7.5t-28 2.5q-70 0-119-49t-49-119q0-14 3.5-28t6.5-28l-81-81Zm287 89Zm-96 96Z"/></svg>

                      
                    ) : (
                      // 🙈 Eye Closed SVG
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="18px"
                        viewBox="0 -960 960 960"
                        width="18px"
                        fill="#434343"
                      >
                        <path d="M480-312q70 0 119-49t49-119q0-70-49-119t-119-49q-70 0-119 49t-49 119q0 70 49 119t119 49Zm0-72q-40 0-68-28t-28-68q0-40 28-68t68-28q40 0 68 28t28 68q0 40-28 68t-68 28Zm0 192q-142.6 0-259.8-78.5Q103-349 48-480q55-131 172.2-209.5Q337.4-768 480-768q142.6 0 259.8 78.5Q857-611 912-480q-55 131-172.2 209.5Q622.6-192 480-192Zm0-288Zm0 216q112 0 207-58t146-158q-51-100-146-158t-207-58q-112 0-207 58T127-480q51 100 146 158t207 58Z" />
                      </svg>
                    )}
                  </span>
                </div>
                {errors.passwordError && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.passwordError}
                  </p>
                )}
              </div>
              <div>

                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Confirm Password<span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <input
                    type={ConfirmPassword ? "text" : "password"}
                    id="confirmPassword"
                    placeholder="Confirm password"
                    // className="mt-1 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs"
                    className={`w-full px-4 py-2 rounded-md border ${
                      errors.confirmPasswordError ? 'border-red-500' : 'border-gray-300'
                    } focus:outline-none focus:ring-2 placeholder:text-xs text-xs pr-10 ${
                      errors.confirmPasswordError ? 'focus:ring-red-400' : 'focus:ring-[#299F1F]'
                    }`}
                    value={formData.confirmPassword}
                    onChange={handleChange}
                  />

                  {/* Eye icon with toggle functionality */}
                  <span
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                    onClick={togglePasswordVisibility1}
                  >
                    {ConfirmPassword ? (
                      // 👁️‍🗨️ Eye Open SVG

                      <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill="#434343"><path d="m637-425-62-62q4-38-23-65.5T487-576l-62-62q13-5 27-7.5t28-2.5q70 0 119 49t49 119q0 14-2.5 28t-8.5 27Zm133 133-52-52q36-28 65.5-61.5T833-480q-49-101-144.5-158.5T480-696q-26 0-51 3t-49 10l-58-58q38-15 77.5-21t80.5-6q143 0 261.5 77.5T912-480q-22 57-58.5 103.5T770-292Zm-2 202L638-220q-38 14-77.5 21t-80.5 7q-143 0-261.5-77.5T48-480q22-57 58-104t84-85L90-769l51-51 678 679-51 51ZM241-617q-35 28-65 61.5T127-480q49 101 144.5 158.5T480-264q26 0 51-3.5t50-9.5l-45-45q-14 5-28 7.5t-28 2.5q-70 0-119-49t-49-119q0-14 3.5-28t6.5-28l-81-81Zm287 89Zm-96 96Z"/></svg>

                      
                    ) : (
                      // 🙈 Eye Closed SVG
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="18px"
                        viewBox="0 -960 960 960"
                        width="18px"
                        fill="#434343"
                      >
                        <path d="M480-312q70 0 119-49t49-119q0-70-49-119t-119-49q-70 0-119 49t-49 119q0 70 49 119t119 49Zm0-72q-40 0-68-28t-28-68q0-40 28-68t68-28q40 0 68 28t28 68q0 40-28 68t-68 28Zm0 192q-142.6 0-259.8-78.5Q103-349 48-480q55-131 172.2-209.5Q337.4-768 480-768q142.6 0 259.8 78.5Q857-611 912-480q-55 131-172.2 209.5Q622.6-192 480-192Zm0-288Zm0 216q112 0 207-58t146-158q-51-100-146-158t-207-58q-112 0-207 58T127-480q51 100 146 158t207 58Z" />
                      </svg>
                    )}
                  </span>
                </div>

                {errors.confirmPasswordError && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.confirmPasswordError}
                  </p>
                )}
              </div>

            </div>

            {/* Terms and Conditions Checkbox */}
            <div className="mt-4 flex gap-2 text-xs">
              <input
                type="checkbox"
                id="termsCheckbox"
                className="w-5 h-5"
                onChange={handleChange}
              />
              <p className="inline-block font-normal text-gray-500">
                By creating an account, you agree to the
                <a
                  href="#"
                  className="text-green-800"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {" "}Terms and Conditions
                </a>, and our
                <a
                  href="#"
                  className="text-green-800"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {" "}Privacy Policy
                </a>.
              </p>
            </div>
            {errors.checkboxError && (
              <p className="text-red-500 text-xs mt-1">{errors.checkboxError}</p>
            )}

            {/* General Error Message */}
            {errors.generalError && (
              <p className="text-red-500 text-xs mt-1">{errors.generalError}</p>
            )}

            {/* Submit Button */}
            <button
              type="submit"
              // className="w-full bg-[#465FFF] text-white py-2 rounded-md mt-4"
              className='w-full mt-4 block text-center bg-[#299F1F] text-white py-2 px-6 rounded-md hover:bg-green-700 transition'
            >
              Sign Up
            </button>

            {/* Sign In Link */}
            <p className="text-sm text-gray-600 mt-4">
              Already have an account?{' '}
              <button
                onClick={handleSignInClick}
                className="text-[#299F1F] hover:underline"
              >
                Sign In
              </button>
            </p>
          </form>
        </div>
      </div>

      {/* Right Side - Banner */}
      <div className="hidden md:flex w-1/2 bg-[#299F1F] justify-center items-center text-white relative px-6 text-center">
        <div>
          <div className="flex items-center gap-2 justify-center">
            <h1 className="text-3xl font-bold">Janta Pay</h1>
          </div>
          <p className="mt-4 text-gray-300">Sign up to unlock secure and smooth payment solutions</p>
        </div>
      </div>
    </div>
  );
};

export default Register;